import { BRAND_COLORS, TRANSPARENT, CHART_RADIAL_GRID_COLOR, WHITE } from '../../../utils/colors';

const STROKE_WIDTH = 1;

const LEGEND = [
  {
    group: 'Highest Score',
    values: [
      {
        color: BRAND_COLORS[3],
        label: 'A',
      },
      {
        color: BRAND_COLORS[2],
        label: 'B+',
      },
      {
        color: BRAND_COLORS[2],
        label: 'B',
      },
      {
        color: BRAND_COLORS[1],
        label: 'C+',
      },
      {
        color: BRAND_COLORS[1],
        label: 'C',
      },
      {
        color: BRAND_COLORS[0],
        label: 'D+',
      },
      {
        color: BRAND_COLORS[0],
        label: 'D',
      },
      {
        color: BRAND_COLORS[0],
        label: 'D*\nNR',
      },
    ],
  },
  {
    group: 'Lowest Score',
    values: [
      {
        color: WHITE,
        label: 'NA\nNU',
      },
    ],
  },
];

export const RADIAL_DEFAULT = {
  legendVisibility: true,
  legendStructure: LEGEND,
  titlesVisibility: true,
  // DATA
  rays: 31,
  extraRays: [],
  dataStrokeWidth: STROKE_WIDTH / 2,
  // RADIUS
  pieOuterRadius: 0.8,
  pieInnerRadius: 0.18,
  labelOuterRadius: 0.92,
  // COLORS
  background: TRANSPARENT,
  colors: BRAND_COLORS,
  // GRID
  gridStroke: CHART_RADIAL_GRID_COLOR,
  gridStrokeWidth: STROKE_WIDTH,
};

export const NO_HEADER = {
  legendVisibility: false,
  titlesVisibility: false,
};

export const NO_HEADER_WITH_EXTRA_RAYS = {
  legendVisibility: false,
  titlesVisibility: false,
  rays: 28,
  extraRays: ['D1', 'D2'],
};

export const getRadialConfig = () => {
  return {
    legendVisibility: true,
    chartHeight: 430,
  };
};
